import {connect} from 'react-redux'
import Navigation from "../components/Navigation";
import {logout} from "../actions";

export default connect(null, {logout})(Navigation)